module.exports = __webpack_public_path__ + "e6ba1f5421701bbb23043f2654c77909.svg";